import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import shortid from "shortid";
import {
  Autocomplete,
  Button,
  CircularProgress,
  CurrencyInput,
  DatePicker,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Switch,
  Tab,
  TabPanel,
  Tabs,
  TextField,
  Tooltip,
} from "../../../components";
import { useImportContext } from "../../../contexts/import.context";
import {
  InputErros,
  LinkTelasHelper,
  PermisoesHelper,
  value,
} from "../../../helpers";
import { AddLayout } from "../../../layouts";
import {
  BancosCaixasService,
  BoletoService,
  CaixaService,
  CentroCustoService,
  ColaboradorService,
  ConfiguracoesService,
  ContasReceberObservacoesService,
  ContasReceberService,
  history,
  MeioPagamentoService,
  notification,
  PessoaService,
  PlanosFinanceirosService,
  PlugBoletoService,
  SessionService,
  UsuarioService,
} from "../../../services";
import {
  formatDate,
  formatPrice,
  responseErros,
  unformatPrice,
  userLogs,
  voltar,
} from "../../../utils";
import {
  boletoSituacoes,
  statusValidosInclusao,
} from "../resources/constantes";
import {
  addIdUsuario,
  addUserNameLista,
  calcularPagamentosParciais,
  calcularValorTotal,
  calcularValorTotalAtualizado,
  tabProps,
} from "./add-contas-receber";
import {
  ButtonMenu,
  DadosPagamento,
  DesdobrarTitulo,
  MenuAddActions,
  Observacoes,
  ReciboPrintLayout,
} from "./components";
import AddInfoBoletoDialog from "./components/add-info-boleto.component";
import { BoletoApiEntity, BoletoEntity, ContaReceber } from "./entities";
import contasReceberValidator from "./middlewares/add-contas-receber.validator";
import ErrosBoletoDialog from "../list-contas-receber/components/boleto/erro-emissao-boleto.dialog";

const meioPagamentoService = new MeioPagamentoService();
const contasReceberService = new ContasReceberService();
const planosFinanceiroService = new PlanosFinanceirosService();
const centroCustoService = new CentroCustoService();
const pessoaService = new PessoaService();
const bancosCaixasService = new BancosCaixasService();
const usuarioService = new UsuarioService();
const linkTelasHelper = new LinkTelasHelper();
const contasReceberObservacoesService = new ContasReceberObservacoesService();
const caixaService = new CaixaService();
const configuracoesService = new ConfiguracoesService();
const sessionService = new SessionService();
const colaboradorService = new ColaboradorService();
const plugBoletoService = new PlugBoletoService();
const boletoService = new BoletoService();

const AddContaReceber = ({ match }) => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("contas-receber-visualizar");
  const { id } = match.params;
  const { contaReceberDto, initialCollapses } = useImportContext();
  const inputPagador = useRef();
  const printComponentRef = useRef(null);
  const [reciboData, setReciboData] = useState(null);
  const [abaValue, setAbaValue] = useState(0);
  const [inputErro, setInputErro] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingAutoCompletePagador, setLoadingAutoCompletePagador] =
    useState(false);
  const [meioPagamento, setMeioPagamento] = useState({
    baixaAutomatica: false,
  });
  const [listaMeiosPagamentos, setListaMeiosPagamentos] = useState([]);
  const [listaContas, setListaContas] = useState([]);
  const [contaReceber, setContaReceber] = useState({
    pago: false,
    dataLancamento: new Date().toISOString(),
  });
  const [pagamento, setPagamento] = useState();
  const [dadosPagamentoList, setDadosPagamentoList] = useState([]);
  const [userLog, setUserLog] = useState({});
  const [observacao, setObservacao] = useState({});
  const [observacaoList, setObservacaoList] = useState([]);
  const [pagadorList, setPagadorList] = useState([]);
  const [jurosMultaEmpresas, setJurosMultaEmpresas] = useState([]);
  const jurosMultaTitulo = jurosMultaEmpresas.find(
    (item) => item.empresaId == contaReceber?.empresaId,
  );
  const parametrosFiscais = jurosMultaTitulo
    ? {
        jurosPorcentagem: jurosMultaTitulo.jurosPorcentagem ?? 0,
        multaPorcentagem: jurosMultaTitulo.multaPorcentagem ?? 0,
        carencia: jurosMultaTitulo.carencia ?? 0,
      }
    : {};
  const [colaborador, setColaborador] = useState({});
  const dadosEmpresa = sessionService.getEmpresaAndUsuario();
  const dadosUsuario = sessionService.getUsuario();
  const [listaPlanosFinanceiros, setListaPlanosFinanceiros] = useState([]);
  const [centroCustoList, setCentroCustoList] = useState([]);

  const [openErrosBoletoDialog, setOpenErrosBoletoDialog] = useState(false);
  const [errosBoleto, setErrosBoleto] = useState(null);
  const [openInfoBoletoDialog, setOpenInfoBoletoDialog] = useState(false);
  const [enderecos, setEnderecos] = useState([]);
  const [convenios, setConvenios] = useState([]);
  const [infoBoleto, setInfoBoleto] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const menuId = "primary-add-actions-menu";
  const DADOS_PAGAMENTO = 0;
  const OBSERVACOES = 1;
  const contasReceberValidatorService = contasReceberValidator(meioPagamento);
  const inputErros = new InputErros(inputErro, setInputErro);
  const tituloOrigemManual = contaReceber?.origem === "MANUAL";
  const tituloEmAberto = contaReceber?.status === "ABERTO";
  const bloquearAlteracaoTitulo =
    Boolean(id) &&
    !permissoesHelper.temPermisao("contas-receber-alterar-vencimento-valor");
  const bloquearValorTitulo =
    bloquearAlteracaoTitulo ||
    (Boolean(id) && (!tituloOrigemManual || !tituloEmAberto));
  const bloquearVencimentoTitulo =
    bloquearAlteracaoTitulo ||
    Boolean(id && !tituloOrigemManual && !tituloEmAberto);
  const bloquearAjusteValores = Boolean(id) && !tituloEmAberto;

  const usuario = sessionService.getUsuario();
  const configuracoes = sessionService.getConfiguracoes();
  const [empresaTitulo, setEmpresaTitulo] = useState(null);

  async function buscarDadosIniciais() {
    await buscarConfiguracoes();
    await buscarPessoaVendedor();
    await buscarContaReceber();
    buscarMeiosPagamentos();
    buscarContas();
    buscarPlanosFinanceiros();
    buscarCentrosCusto();
  }

  useEffect(() => {
    buscarDadosIniciais();
  }, []);

  async function buscarPessoaVendedor(filtros) {
    const filtro = {
      ...filtros,
      nonPaginated: true,
      vendedor: true,
    };
    const result = await colaboradorService.getAll(filtro);
    if (!result.isAxiosError) {
      const colaboradorVendedorUsuario = result.data.find(
        (colaborador) => colaborador.usuarioId === dadosUsuario.id,
      );
      const permissaoCaixaColaborador = await permissoesHelper.temPermisao(
        "utilizar-caixa-colaborador",
      );
      if (colaboradorVendedorUsuario && permissaoCaixaColaborador) {
        setPagamento((prevState) => ({
          ...prevState,
          bancoCaixaId: colaboradorVendedorUsuario.bancoCaixaId,
        }));
        setColaborador(colaboradorVendedorUsuario);
      }
    } else {
      responseErros(result);
    }
  }

  const buscaUsuario = async (listaIdUsuario) => {
    if (listaIdUsuario.length) {
      const filtro = {
        nonPaginated: true,
        id: listaIdUsuario,
      };
      usuarioService.getAll(filtro).then((result) => {
        if (!result.isAxiosError) {
          setDadosPagamentoList((prevState) => {
            return addUserNameLista(prevState, result.data);
          });
          setObservacaoList((prevState) => {
            return addUserNameLista(prevState, result.data);
          });
        } else {
          responseErros(result);
        }
      });
    }
  };

  const buscarContaReceber = async () => {
    if (id) {
      setLoading(true);
      const result = await contasReceberService.getById(id);
      if (!result.isAxiosError) {
        if (!result.data) {
          initialCollapses();
          voltar();
          return;
        }
        buscarPagador({ id: result.data.pagadorId });
        setEmpresaTitulo(
          value.autoComplete(
            usuario.acessosEmpresas || [],
            result.data.empresaId,
          )?.fantasia,
        );
        const boleto = result.data.boleto;
        if (boleto?.id && !statusValidosInclusao.includes(boleto.status)) {
          await consultarSituacao(boleto);
        }
        setDadosContasReceber({ ...result.data, boleto });
        setDadosPagamentoList(
          result.data.pagamentos.map((pagamento) => ({
            ...pagamento,
            horaPagamento: pagamento.dataPagamento,
          })),
        );
        setObservacaoList(result.data.observacaoList);
        const listaIdUsuario = [];
        addIdUsuario(result.data.observacaoList, listaIdUsuario);
        addIdUsuario(result.data.pagamentos, listaIdUsuario);
        buscaUsuario(listaIdUsuario);
        buscaMeioPagamentoById(result.data.meioPagamentoId);
      } else {
        responseErros(result);
      }
      setLoading(false);
    } else {
      const linkBody = linkTelasHelper.get();
      if (linkBody) {
        setContaReceber(linkBody);
      } else {
        setContaReceber(contaReceberDto);
      }
    }
  };

  async function onClickLog() {
    if ("userCreatedLog" in userLog) return;
    const logs = await userLogs(contaReceber);
    setUserLog(logs);
  }

  const buscarConfiguracoes = async () => {
    if (!id) return;
    configuracoesService.getJurosMulta().then((result) => {
      if (!result.isAxiosError) {
        setJurosMultaEmpresas(result.data);
      }
    });
  };

  const buscarCentrosCusto = async function () {
    const filtros = {
      nonPaginated: true,
    };
    const result = await centroCustoService.getAll(filtros);
    if (!result.isAxiosError) {
      setCentroCustoList(result.data);
    } else {
      responseErros(result);
    }
  };

  const buscarContas = async function () {
    const filtros = {
      nonPaginated: true,
      ativado: true,
    };
    const result = await bancosCaixasService.getAll(filtros);
    if (!result.isAxiosError) {
      setListaContas(result.data);
    } else {
      responseErros(result);
    }
  };

  const buscarPagador = async (filtros) => {
    const filtro = {
      ...filtros,
      nonPaginated: true,
      ativado: true,
    };
    pessoaService.getAll(filtro).then((res) => {
      setLoadingAutoCompletePagador(false);
      if (!res.isAxiosError) {
        setPagadorList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarPlanosFinanceiros = () => {
    const filtros = {
      nonPaginated: true,
      natureza: "credito",
    };
    planosFinanceiroService.getAll(filtros).then((res) => {
      if (!res.isAxiosError) {
        setListaPlanosFinanceiros(res.data);
        if (!id) return;
        const planoRecebimento = res.data.find(
          (p) => (p.descricao || "").toLowerCase() == "recebimento",
        );
        if (planoRecebimento) {
          setPagamento((prevState) => ({
            ...prevState,
            planoFinanceiroId: planoRecebimento.id,
          }));
        }
      } else {
        responseErros(res);
      }
    });
  };

  const buscarMeiosPagamentos = () => {
    const filtros = {
      ativado: true,
      nonPaginated: true,
    };
    if (contaReceberDto?.tipo === "NOTA_CREDITO") {
      filtros.nfePagamento = "fpCreditoEmLoja";
    }
    meioPagamentoService.getAll(filtros).then((res) => {
      if (!res.isAxiosError) {
        setListaMeiosPagamentos(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  async function buscaMeioPagamentoById(id) {
    meioPagamentoService.getById(id).then((result) => {
      if (!result.isAxiosError) {
        setMeioPagamento(result.data);
      } else {
        responseErros(result);
      }
    });
  }

  function setDadosContasReceber(contaReceber) {
    const valorTotal = calcularValorTotal(contaReceber);
    const contaReceberTemp = {
      ...contaReceber,
      valorTotal,
      pagamentosParciais: calcularPagamentosParciais(contaReceber.pagamentos),
      saldoReceber: calcularValorTotalAtualizado(contaReceber),
    };
    setContaReceber(contaReceberTemp);
    const pagamentoTemp = {
      tipoBaixa: "BAIXA_NORMAL",
      dataPagamento: new Date(),
      bancoCaixaId: meioPagamento?.bancoCaixaId,
      planoFinanceiroId: contaReceber?.planoFinanceiroId,
      valor: calcularValorTotalAtualizado(contaReceber),
    };
    if (contaReceber.status === "BAIXADO") {
      const ultimoPagamento =
        contaReceber.pagamentos[contaReceber.pagamentos.length - 1];
      const { bancoCaixaId, dataPagamento, meioPagamentoId, juros, multa } =
        ultimoPagamento;
      Object.assign(pagamentoTemp, {
        bancoCaixaId,
        dataPagamento,
        meioPagamentoId,
        juros,
        multa,
      });
    }
    setPagamento(pagamentoTemp);
  }

  async function consultarSituacao(boleto) {
    setLoading(true);

    const params = `idintegracao=${boleto.integradorId}`;
    const result = await plugBoletoService.consultarSituacao(
      params,
      dadosEmpresa.empresa.cnpjCpf,
    );
    if (!result.ok) {
      responseErros(result);
      setLoading(false);
      notification.alertaGenericos("Erro ao consultar boletos");
    }
    const response = await result.json();
    const boletosApi = response._dados;
    if (boletosApi?.length) {
      const boletoAtual = boletosApi[0];
      if (boleto.status !== boletoAtual.situacao) {
        const updateBody = [
          {
            id: boleto.id,
            status: boletoAtual.situacao,
          },
        ];
        const res = await boletoService.update(updateBody);
        if (!res.isAxiosError) {
          boleto.status = boletoAtual.situacao;
        } else {
          responseErros(result);
        }
      }
    }
    setLoading(false);
  }

  async function gerarBoleto(cliente, contaBancaria, endereco, convenio) {
    const boletoApi = new BoletoApiEntity(
      contaReceber,
      cliente,
      endereco,
      contaBancaria,
      convenio,
    );
    const apiResponse = await plugBoletoService.incluirBoletosLote(
      [boletoApi],
      dadosEmpresa.empresa?.cnpjCpf,
    );
    if (apiResponse._dados?._sucesso?.length) {
      const boletoResponse = apiResponse._dados._sucesso[0];
      const body = new BoletoEntity(
        boletoResponse,
        contaReceber,
        convenio,
        cliente.id,
      );
      const res = await boletoService.cadastrar(body);
      if (!res.isAxiosError) {
        notification.sucessoGenericos(
          "Emissão de boleto realizada com sucesso",
        );
        await buscarContaReceber();
      } else {
        responseErros(res);
      }
    } else {
      const erro = apiResponse._dados?._falha?.[0]._erro?.erros;
      const mensagemErro = erro
        ? `${Object.keys(erro)[0]} - ${Object.values(erro)[0]}`
        : "Erro ao emitir boleto";
      notification.erroGenericos(mensagemErro);
    }
  }

  async function validarInclusaoBoleto() {
    setLoading(true);
    const cliente = pagadorList[0],
      contaBancaria = listaContas.find(
        ({ id }) => contaReceber.bancoCaixaId === id,
      );
    if (
      cliente.enderecos?.length === 0 ||
      contaBancaria.convenios?.length === 0
    ) {
      notification.erroGenericos(
        "Informações de Endereço/Convênio faltando para a emissão de boletos",
      );
    } else if (
      cliente.enderecos?.length === 1 &&
      contaBancaria.convenios?.length === 1
    ) {
      await gerarBoleto(
        cliente,
        contaBancaria,
        cliente.enderecos[0],
        contaBancaria.convenios[0],
      );
    } else {
      setEnderecos(cliente.enderecos);
      setConvenios(contaBancaria.convenios);
      setInfoBoleto({
        cliente,
        contaBancaria,
        enderecoSelecionado: cliente.enderecos[0],
        convenioSelecionado: contaBancaria.convenios[0],
      });
      setOpenInfoBoletoDialog(true);
    }
    setLoading(false);
  }

  const onSearchChangePagador = (event) => {
    if (
      event.key === "Enter" &&
      inputPagador.current === document.activeElement
    ) {
      const eventValue = event.target?.value;
      let filtros = {
        nomeRazaoSocial: eventValue,
        apelidoFantasia: eventValue,
      };
      setLoadingAutoCompletePagador(true);
      buscarPagador(filtros);
    }
  };

  const onClickSalvar = (indiceSelecionado) => {
    const body = {
      ...contaReceber,
      observacaoList,
      bancoCaixaId: meioPagamento?.bancoCaixaId || contaReceber?.bancoCaixaId,
      pagamentos: dadosPagamentoList,
    };
    validarContaReceber(body, indiceSelecionado);
  };

  const validarStatusCaixa = async (dataPagamento, bancoCaixaId) => {
    const result = await caixaService.caixaAberto(dataPagamento, bancoCaixaId);
    if (!result.isAxiosError) {
      return result.data;
    } else {
      responseErros(result);
    }
  };

  const validarContasReceber = (body) => {
    if (!meioPagamento?.baixaAutomatica && !body.pagadorId) {
      notification.alertaGenericos("É necessário informar cliente pagador");
      setLoading(false);
      return false;
    }
    return true;
  };

  const validarContaReceber = (body, indiceSelecionado) => {
    setInputErro([]);
    contasReceberValidatorService
      .validate(body, { abortEarly: false })
      .then(async () => {
        const isValid = validarContasReceber(body);
        if (!isValid) return;
        const dadosContaReceber = new ContaReceber(
          body,
          meioPagamento,
          colaborador,
        );
        if (id) {
          setLoading(true);
          await atualizarContaReceber(id, dadosContaReceber, indiceSelecionado);
          setLoading(false);
        } else {
          if (dadosContaReceber?.baixaAposInclusao) {
            const caixaAberto = await validarStatusCaixa(
              dadosContaReceber.dataLancamento,
              dadosContaReceber.bancoCaixaId,
            );
            if (!caixaAberto) {
              const caixaSelecionado = listaContas.find(
                (conta) => conta.id === dadosContaReceber?.bancoCaixaId,
              );
              if (caixaSelecionado?.aberturaAutomatica) {
                await cadastrarCaixa(
                  new Date(),
                  dadosContaReceber?.bancoCaixaId,
                  true,
                );
              } else return notification.alertaGenericos("Caixa Fechado!");
            }
            setLoading(true);
            await salvarContasReceber(dadosContaReceber, indiceSelecionado);
            setLoading(false);
          } else {
            setLoading(true);
            await salvarContasReceber(dadosContaReceber, indiceSelecionado);
            setLoading(false);
          }
        }
      })
      .catch((err) => {
        inputErros.set(err);
      });
  };

  const cadastrarCaixa = async (dataCadastro, bancoCaixaId, aberto) => {
    setLoading(true);
    const body = {
      data: dataCadastro,
      bancoCaixaId,
      aberto,
    };
    const result = await caixaService.cadastrar(body);
    if (result.isAxiosError) {
      setLoading(false);
      responseErros(result);
    }
  };

  const onChangeAba = (e, value) => {
    setAbaValue(value);
  };

  const onChangeAutocomplete = (name, value) => {
    if (
      name === "planoFinanceiroId" &&
      value &&
      !pagamento?.planoFinanceiroId
    ) {
      setPagamento((prevState) => ({
        ...prevState,
        planoFinanceiroId: value.id,
      }));
    }
    setContaReceber({
      ...contaReceber,
      [name]: value ? value.id : null,
    });
  };

  const onBlurInput = (event) => {
    const contaReceberTemp = {
      ...contaReceber,
      [event.target.name]: unformatPrice(event.target.value),
    };
    contaReceberTemp.valorTotal = calcularValorTotal(contaReceberTemp);
    contaReceberTemp.saldoReceber =
      contaReceberTemp.valorTotal -
      parseFloat(contaReceberTemp.pagamentosParciais ?? 0);
    setContaReceber(contaReceberTemp);
  };

  const onChangeInput = (event) => {
    setContaReceber({
      ...contaReceber,
      [event.target.name]: event.target.value,
    });
  };

  const handleDateChange = (date, fieldName) => {
    const isValidDate = (d) => d instanceof Date && !isNaN(d);
    if (!date || !isValidDate(date) || date.getFullYear() < 2000) {
      date = "Invalid Date";
    }
    setContaReceber((prevState) => ({
      ...prevState,
      [fieldName]: date != "Invalid Date" ? formatDate.toSend(date) : null,
    }));
  };

  const handleObservacao = async (event) => {
    event.preventDefault();
    if (id) {
      cadastrarObservacao(id, observacao.id);
    } else {
      setObservacaoList((prevState) => [
        ...prevState,
        {
          id: shortid.generate(),
          ...observacao,
        },
      ]);
      setObservacao({});
    }
  };

  const buscarObservacoes = (contasReceberId) => {
    const filter = {
      contasReceberId,
    };
    contasReceberObservacoesService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setObservacaoList(res.data.rows);
        const listaIdUsuario = res.data.rows.map(
          (observacao) => observacao.updatedUserId || observacao.insertUserId,
        );
        buscaUsuario(listaIdUsuario);
      } else {
        responseErros(res);
      }
    });
  };

  const cadastrarObservacao = async (contasReceberId, observacaoId) => {
    setLoading(true);
    const body = {
      ...observacao,
      contasReceberId,
    };
    let res = {};
    if (observacaoId) {
      res = await contasReceberObservacoesService.atualizar(observacaoId, body);
    } else {
      res = await contasReceberObservacoesService.cadastrar(body);
    }
    setLoading(false);
    if (!res.isAxiosError) {
      setObservacao("");
      buscarObservacoes(contasReceberId);
      notification.cadastroSucesso();
    } else {
      responseErros(res);
    }
  };

  const handleChangeObservacao = (e) => {
    setObservacao((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleChangeSwitch = (event) => {
    setInputErro([]);
    const contaReceberTemp = {
      ...contaReceber,
      [event.target.name]: event.target.checked,
    };
    setContaReceber(contaReceberTemp);
  };

  const removerObservacao = async (id) => {
    setLoading(true);
    const res = await contasReceberObservacoesService.deletar(id);
    setLoading(false);
    if (!res.isAxiosError) {
      const data = observacaoList.filter((item) => item.id !== id);
      setObservacaoList(data);
      notification.deletadoSucesso();
    } else {
      responseErros(res);
    }
  };

  const limparFormularios = () => {
    setAbaValue(0);
    setInputErro([]);
    setContaReceber({
      pago: false,
      dataLancamento: new Date().toISOString(),
    });
    setObservacaoList([]);
    setDadosPagamentoList([]);
  };

  const salvarContasReceber = async (dadosContaReceber, indiceSelecionado) => {
    const cliente = pagadorList.find(
      (item) => item.id == contaReceber.pagadorId,
    );
    setLoading(true);
    const res = await contasReceberService.cadastrar(dadosContaReceber);
    setLoading(false);
    if (!res.isAxiosError) {
      if (id || contaReceber.baixaAposInclusao) {
        setReciboData({
          cliente,
          titulo: res.data,
          pagamentos: res.data?.pagamentos ? [res.data.pagamentos[0]] : [],
        });
        handlePrint();
      }
      notification.cadastroSucesso();
      if (indiceSelecionado === 0) {
        history.goBack();
      } else {
        limparFormularios();
      }
    } else {
      responseErros(res);
    }
  };

  const atualizarContaReceber = async (
    idContaReceber,
    dadosContaReceber,
    indiceSelecionado,
  ) => {
    dadosContaReceber.removerObservacaoList(idContaReceber);
    const res = await contasReceberService.atualizar(
      idContaReceber,
      dadosContaReceber,
    );
    if (!res.isAxiosError) {
      if (indiceSelecionado === 0) {
        notification.alteracaoSucesso();
        history.push("/financeiro/contas-receber");
      }
    } else {
      const error = res.response ? res.response.data.error : res.message;
      notification.erroValidacao(error);
    }
    setLoading(false);
  };

  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
    pageStyle: `
      @page {
        size: auto;
        margin: 8mm;
      }
    `,
  });

  const handleAddActionsOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const renderLabelSituacao = (situacao) => {
    const status = boletoSituacoes.find((item) => item.nome === situacao);
    return status?.label ?? "";
  };

  const renderIconSituacao = (situacao) => {
    const status = boletoSituacoes.find((item) => item.nome === situacao);
    return status ? (
      <InputAdornment position="start">
        <i
          className="ph-fill ph-circle"
          style={{ color: status.cor, fontSize: 18 }}
        ></i>
      </InputAdornment>
    ) : (
      ""
    );
  };

  const renderErroSituacao = (boleto) => {
    return boleto.status === "FALHA" ? (
      <InputAdornment position="end">
        <Tooltip title="Exibir observações" arrow placement="top">
          <IconButton
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              padding: 0,
              borderRadius: "50%",
              color: "#A61E3C",
              "&:hover": {
                backgroundColor: "#A61E3C",
                color: "#F5F5F5"
              },
            }}
            onClick={() => {
              setErrosBoleto(boleto.observacoes);
              setOpenErrosBoletoDialog(true);
            }}
          >
            <i
              className="ph-fill ph-warning"
              aria-hidden="true"
              style={{
                display: "block",
                fontSize: 18,
                color: "currentColor",
              }}
            ></i>
          </IconButton>
        </Tooltip>
      </InputAdornment>
    ) : (
      <></>
    );
  };

  return (
    <AddLayout
      id={id}
      title={id ? "Editar Conta a Receber" : "Cadastrar Conta a Receber"}
      onClickSalvar={onClickSalvar}
      loading={loading}
      userLog={id ? userLog : null}
      onClickLog={onClickLog}
      codigo={id ? `Nº Título - ${contaReceber.numeroTitulo}` : null}
      showUpdate={permissoesHelper.temPermisao("contas-receber-editar")}
      ButtonMenu={
        <ButtonMenu
          contaReceber={contaReceber}
          setContaReceber={setContaReceber}
        />
      }
      actions={
        <div>
          {!contaReceber?.id ? (
            <FormControlLabel
              control={
                <Switch
                  id="baixaAposInclusao"
                  name="baixaAposInclusao"
                  checked={
                    contaReceber?.baixaAposInclusao
                      ? contaReceber?.baixaAposInclusao
                      : false
                  }
                  onChange={handleChangeSwitch}
                  color="primary"
                />
              }
              label={`Baixa após inclusão`}
            />
          ) : (
            <Button
              aria-label="add action conta receber"
              aria-controls={menuId}
              aria-haspopup="true"
              aria-expanded={isMenuOpen ? "true" : "false"}
              onClick={handleAddActionsOpen}
              color="inherit"
              style={{
                borderRadius: 5,
                backgroundColor: "#E5E5E5",
              }}
            >
              <span style={{ fontSize: 10 }}>mais ações</span>
            </Button>
          )}
        </div>
      }
    >
      {usuario.acessosEmpresas?.length > 0 && id && (
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField
              id="empresaTitulo"
              label="Empresa"
              variant="filled"
              margin="normal"
              disabled
              value={empresaTitulo}
              fullWidth
              sx={{ mt: -2 }}
            />
          </Grid>
        </Grid>
      )}
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="pagadorId"
              name="pagadorId"
              options={pagadorList}
              autoHighlight
              loading={loadingAutoCompletePagador}
              disabled={contaReceber?.id ? true : false}
              getOptionLabel={(option) => {
                if (option.nomeRazaoSocial) {
                  if (option.codigo) {
                    return `${option.codigo} - ${option.nomeRazaoSocial}`;
                  }
                  return option.nomeRazaoSocial;
                }
              }}
              getOptionSelected={(option, value) =>
                option?.nomeRazaoSocial === value?.nomeRazaoSocial
              }
              noOptionsText="Digite e pressione Enter"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Pagador"
                  variant={contaReceber?.id ? "filled" : "outlined"}
                  onKeyDown={(e) => onSearchChangePagador(e)}
                  inputRef={inputPagador}
                  error={inputErros.get("pagadorId")}
                  required={!meioPagamento?.baixaAutomatica}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        <React.Fragment>
                          {loadingAutoCompletePagador ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      </>
                    ),
                  }}
                />
              )}
              onChange={(e, value) => onChangeAutocomplete("pagadorId", value)}
              value={value.autoComplete(pagadorList, contaReceber?.pagadorId)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="numeroTitulo"
            name="numeroTitulo"
            label="Nº Título"
            variant="filled"
            margin="normal"
            disabled
            value={value.text(contaReceber?.numeroTitulo)}
            fullWidth
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="origem"
            name="origem"
            label="Origem"
            variant="filled"
            margin="normal"
            disabled
            value={value.text(contaReceber?.origem)}
            fullWidth
          />
        </Grid>
        <Grid item xs={2}>
          <DatePicker
            id="dataLancamento"
            name="dataLancamento"
            label="Data de Lançamento"
            format="dd/MM/yyyy"
            variant="filled"
            margin
            disabled
            value={
              contaReceber?.dataLancamento ? contaReceber.dataLancamento : null
            }
          />
        </Grid>
        <Grid item xs={2}>
          <DatePicker
            id="dataVencimento"
            name="dataVencimento"
            label="Data de Vencimento"
            format="dd/MM/yyyy"
            variant={bloquearVencimentoTitulo ? "filled" : "outlined"}
            disabled={bloquearVencimentoTitulo}
            margin
            error={inputErros.get("dataVencimento")}
            required
            value={
              contaReceber?.dataVencimento ? contaReceber.dataVencimento : null
            }
            onChange={(date) => handleDateChange(date, "dataVencimento")}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="meioPagamento"
              name="meioPagamento"
              noOptionsText="Sem opções"
              options={listaMeiosPagamentos}
              autoHighlight
              getOptionLabel={(option) =>
                option?.descricao ? option?.descricao : ""
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Meio de Pagamento"
                  variant="outlined"
                  required
                  error={inputErros.get("meioPagamentoId")}
                />
              )}
              onChange={(e, value) => {
                onChangeAutocomplete("meioPagamentoId", value);
                setMeioPagamento(value);
              }}
              value={value.autoComplete(
                listaMeiosPagamentos,
                contaReceber?.meioPagamentoId,
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <CurrencyInput
            id="valor"
            name="valor"
            label="Valor Bruto (R$)"
            variant={bloquearValorTitulo ? "filled" : "outlined"}
            disabled={bloquearValorTitulo}
            error={inputErros.get("valor")}
            required
            value={value.text(contaReceber?.valor)}
            onBlur={onBlurInput}
          />
        </Grid>
        <Grid item xs={2}>
          <CurrencyInput
            id="acrescimo"
            name="acrescimo"
            label="Acréscimo (R$)"
            variant={bloquearAjusteValores ? "filled" : "outlined"}
            disabled={bloquearAjusteValores}
            value={contaReceber.acrescimo ?? "0"}
            onBlur={onBlurInput}
          />
        </Grid>
        <Grid item xs={2}>
          <CurrencyInput
            id="desconto"
            name="desconto"
            label="Desconto (R$)"
            variant={bloquearAjusteValores ? "filled" : "outlined"}
            disabled={bloquearAjusteValores}
            value={contaReceber?.desconto ?? "0"}
            onBlur={onBlurInput}
            fullWidth
          />
        </Grid>
        <Grid item xs={2}>
          <CurrencyInput
            id="pagamentosParciais"
            name="pagamentosParciais"
            label="Recebimento Realizado (R$)"
            variant="filled"
            fullWidth
            value={contaReceber?.pagamentosParciais ?? "0"}
            disabled
          />
        </Grid>
      </Grid>
      {contaReceber?.boleto && (
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <TextField
              id="boletoSituacao"
              name="boletoSituacao"
              label="Situação"
              variant="filled"
              margin="normal"
              disabled
              fullWidth
              value={renderLabelSituacao(
                contaReceber?.boleto.status,
              ).toUpperCase()}
              InputProps={{
                startAdornment: renderIconSituacao(contaReceber?.boleto.status),
                endAdornment: renderErroSituacao(contaReceber?.boleto),
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              id="boletoNossoNumero"
              name="boletoNossoNumero"
              label="Nosso Número"
              variant="filled"
              margin="normal"
              disabled
              fullWidth
              value={contaReceber?.boleto.tituloNossoNumero}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              id="boletoIntegradorId"
              name="boletoIntegradorId"
              label="Integrador"
              variant="filled"
              margin="normal"
              disabled
              value={value.text(contaReceber?.boleto.integradorId)}
              fullWidth
            />
          </Grid>
          <Grid item xs={3}>
            <DatePicker
              id="boletoDataVencimento"
              name="boletoDataVencimento"
              label="Data de Vencimento"
              format="dd/MM/yyyy"
              variant="filled"
              margin="normal"
              disabled
              value={contaReceber?.boleto?.dataVencimento ?? null}
            />
          </Grid>
        </Grid>
      )}
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="planoFinanceiroId"
              name="planoFinanceiroId"
              options={listaPlanosFinanceiros}
              noOptionsText="Sem opções"
              autoHighlight
              getOptionLabel={(option) =>
                option.descricao
                  ? `${option.codigo}` + ` - ` + `${option.descricao}`
                  : ""
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Plano Financeiro"
                  variant="outlined"
                  error={inputErros.get("planoFinanceiroId")}
                />
              )}
              onChange={(e, value) =>
                onChangeAutocomplete("planoFinanceiroId", value)
              }
              value={value.autoComplete(
                listaPlanosFinanceiros,
                contaReceber.planoFinanceiroId,
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              required
              id="centroCustoId"
              name="centroCustoId"
              options={centroCustoList}
              autoHighlight
              getOptionLabel={(option) =>
                option.descricao
                  ? `${option.codigo}` + ` - ` + `${option.descricao}`
                  : ""
              }
              getOptionSelected={(option, value) =>
                option.descricao === value.descricao
              }
              noOptionsText="Sem opções"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Centro Custo"
                  variant="outlined"
                  error={inputErros.get("centroCustoId")}
                />
              )}
              onChange={(e, newValue) => {
                e.persist();
                onChangeAutocomplete("centroCustoId", newValue);
              }}
              value={value.autoComplete(
                centroCustoList,
                contaReceber.centroCustoId,
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            id="historico"
            name="historico"
            label="Histórico"
            variant="outlined"
            margin="normal"
            value={value.text(contaReceber?.historico)}
            onChange={(e) => onChangeInput(e)}
            fullWidth
          />
        </Grid>
        <Grid item xs={3} className="mt-3">
          <Paper
            className="py-2 px-2 text-white text-center"
            elevation={4}
            sx={{ backgroundColor: "#2196F3" }}
          >
            Valor Total
            <br />
            <span className="fs-6">
              {formatPrice(parseFloat(contaReceber?.valorTotal || 0))}
            </span>
          </Paper>
        </Grid>
        <Grid item xs={3}>
          <CurrencyInput
            id="saldoReceber"
            name="saldoReceber"
            label="Saldo a Receber (R$)"
            variant="filled"
            fullWidth
            value={value.text(contaReceber?.saldoReceber) || "0"}
            disabled
          />
        </Grid>
      </Grid>
      {!id && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DesdobrarTitulo
              contaReceber={contaReceber}
              meioPagamento={meioPagamento}
              dadosPagamentoList={dadosPagamentoList}
              observacaoList={observacaoList}
              inputErros={inputErros}
              setInputErro={setInputErro}
            />
          </Grid>
        </Grid>
      )}
      {contaReceber?.id && (
        <Grid container spacing={2} className="mt-3">
          <Grid item xs={12}>
            <Paper>
              <Tabs
                value={abaValue}
                onChange={onChangeAba}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                scrollButtons="auto"
              >
                <Tab
                  label="Dados do Pagamento"
                  {...tabProps(DADOS_PAGAMENTO)}
                />
                <Tab label="Observações" {...tabProps(OBSERVACOES)} />
              </Tabs>
            </Paper>
            <TabPanel value={abaValue} index={DADOS_PAGAMENTO}>
              <DadosPagamento
                id={id}
                setLoading={setLoading}
                contaReceber={contaReceber}
                setContaReceber={setContaReceber}
                setDadosContaReceber={setDadosContasReceber}
                pagamento={pagamento}
                setPagamento={setPagamento}
                pagadorList={pagadorList}
                listaContas={listaContas}
                listaMeiosPagamentos={listaMeiosPagamentos}
                dadosPagamentoList={dadosPagamentoList}
                setDadosPagamentoList={setDadosPagamentoList}
                validarStatusCaixa={validarStatusCaixa}
                setReciboData={setReciboData}
                handlePrint={handlePrint}
                parametrosFiscais={parametrosFiscais}
                cadastrarCaixa={cadastrarCaixa}
                colaborador={colaborador}
                onClickSalvar={onClickSalvar}
                listaPlanosFinanceiros={listaPlanosFinanceiros}
                configuracoes={configuracoes}
              />
            </TabPanel>
            <TabPanel value={abaValue} index={OBSERVACOES}>
              <Observacoes
                observacao={observacao}
                handleChangeObservacao={handleChangeObservacao}
                handleObservacao={handleObservacao}
                removerObservacao={removerObservacao}
                observacaoList={observacaoList}
                setObservacao={setObservacao}
              />
            </TabPanel>
          </Grid>
        </Grid>
      )}
      <div style={{ display: "none" }}>
        <div ref={printComponentRef}>
          <ReciboPrintLayout data={reciboData} />
        </div>
      </div>
      <MenuAddActions
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        conta={contaReceber}
        pagamento={pagamento}
        dadosEmpresa={dadosEmpresa}
        listaMeiosPagamentos={listaMeiosPagamentos}
        dadosPagamentoList={dadosPagamentoList}
        listaContas={listaContas}
        pagadorList={pagadorList}
        setReciboData={setReciboData}
        handlePrint={handlePrint}
        buscarContaReceber={buscarContaReceber}
        validarInclusaoBoleto={validarInclusaoBoleto}
        meioPagamento={meioPagamento}
        setLoading={setLoading}
      />
      <AddInfoBoletoDialog
        open={openInfoBoletoDialog}
        setOpen={setOpenInfoBoletoDialog}
        enderecos={enderecos}
        convenios={convenios}
        boleto={infoBoleto}
        setBoleto={setInfoBoleto}
        gerarBoleto={gerarBoleto}
        setLoading={setLoading}
      />
      <ErrosBoletoDialog
        open={openErrosBoletoDialog}
        setOpen={setOpenErrosBoletoDialog}
        erros={errosBoleto}
      />
    </AddLayout>
  );
};

export default AddContaReceber;
